import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { getQueryClient } from './lib/queryClient';
import { AuthProvider } from './contexts/AuthContext';
import { SidebarRefreshProvider } from './contexts/SidebarRefreshContext';
import { PermissionsProvider } from './contexts/PermissionsContext';
import { NotificationProvider } from './components/NotificationProvider';
import { GlobalLockStatusChecker } from './components/GlobalLockStatusChecker';
import { LockedAccountOverlay } from './components/LockedAccountOverlay';
import ProtectedRoute from './components/ProtectedRoute';
import OnboardingRoute from './components/OnboardingRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import MaintenanceMode from './pages/MaintenanceMode';
import LockedAccount from './pages/LockedAccount';
import Welcome from './pages/Welcome';
import Join from './pages/Join';
import Company from './pages/Company';
import Dashboard from './pages/Dashboard';
import Requests from './pages/Requests';
import RequestDetail from './pages/RequestDetail';
import CreateRequest from './pages/CreateRequest';
import Reports from './pages/Reports';
import Help from './pages/Help';
import Developer from './pages/Developer';
import SettingsUsers from './pages/SettingsUsers';
import SettingsRoles from './pages/SettingsRoles';
import SettingsCompany from './pages/SettingsCompany';
import SettingsBranches from './pages/SettingsBranches';
import SettingsBilling from './pages/SettingsBilling';
import SettingsRequests from './pages/SettingsRequests';

function App() {
  return (
    <QueryClientProvider client={getQueryClient()}>
      <AuthProvider>
        <GlobalLockStatusChecker />
        <NotificationProvider>
          <PermissionsProvider>
            <SidebarRefreshProvider>
              <BrowserRouter>
                <Routes>
                  <Route path="/login" element={<Login />} />
                  <Route path="/maintenance-mode" element={<MaintenanceMode />} />
                  <Route path="/locked" element={<LockedAccount />} />
                  <Route path="/welcome" element={<OnboardingRoute><Welcome /></OnboardingRoute>} />
                  <Route path="/join" element={<OnboardingRoute><Join /></OnboardingRoute>} />
                  <Route path="/company" element={<OnboardingRoute><Company /></OnboardingRoute>} />
                  <Route
                    path="/"
                    element={
                      <ProtectedRoute>
                        <Layout />
                      </ProtectedRoute>
                    }
                  >
                    <Route index element={<Navigate to="/dashboard" replace />} />
                    <Route path="dashboard" element={<Dashboard />} />
                    <Route path="requests" element={<Requests />} />
                    <Route path="requests/:id" element={<RequestDetail />} />
                    <Route path="create-request" element={<CreateRequest />} />
                    <Route path="reports" element={<Reports />} />
                    <Route path="settings/users" element={<SettingsUsers />} />
                    <Route path="settings/roles" element={<SettingsRoles />} />
                    <Route path="settings/company" element={<SettingsCompany />} />
                    <Route path="settings/branches" element={<SettingsBranches />} />
                    <Route path="settings/billing" element={<SettingsBilling />} />
                    <Route path="settings/setup" element={<SettingsRequests />} />
                    <Route path="developer/:tab" element={<Developer />} />
                    <Route path="developer" element={<Developer />} />
                  </Route>
                  <Route path="/help" element={<ProtectedRoute><Help /></ProtectedRoute>} />
                </Routes>
              </BrowserRouter>
              <LockedAccountOverlay />
            </SidebarRefreshProvider>
          </PermissionsProvider>
        </NotificationProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;

